export default defineAppConfig({
  title: 'Author Tool',
  theme: {
    dark: false,
    colors: {
      primary: '#ff0000',
    },
  },
});
